// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductImage_container__2mhna"};